export default __webpack_public_path__ + "static/media/close_button.b80e3763.png";